import { render, staticRenderFns } from "./shebeiTrouble.vue?vue&type=template&id=68939390&scoped=true&"
import script from "./shebeiTrouble.vue?vue&type=script&lang=js&"
export * from "./shebeiTrouble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68939390",
  null
  
)

export default component.exports